import _CircularProgress from "@material-ui/core/esm/CircularProgress";
import React from 'react';
import classnames from 'classnames';
import CSSClasses from './loading.scss';
const styles = {
  colorPrimary: CSSClasses.colorPrimary
};
const Loading = props => {
  const {
    style,
    className,
    hasOverlay,
    size = 50
  } = props;
  return /*#__PURE__*/React.createElement("div", {
    className: classnames(className, CSSClasses.root, {
      [CSSClasses.overlay]: hasOverlay
    })
  }, /*#__PURE__*/React.createElement(_CircularProgress, {
    classes: styles,
    style: style,
    size: size
  }));
};
export default Loading;